// Import the signature images
import ojali_signature from "./images/27-03-2023.png";
import adebayo_signature from "./images/7-01-2025.png";
import olufunke_signature from "./images/08-04-2025.png";
import edet_signature from "./images/08-04-2026.png";

// Helper: safe date parser
const toDate = (d) => (d ? new Date(d) : null);

// Central timeline (single source of truth)
const TIMELINE = [
  {
    start: "2023-03-27",
    end: "2025-01-06",
    name: "ACP Edino J OJali",
    rank: "Asst. Commissioner of Police (CMR)",
    signature: ojali_signature,
  },
  {
    start: "2025-01-07",
    end: "2025-04-07",
    name: "ACP Adebayo Adedayo",
    rank: "Asst. Commissioner of Police (CMR)",
    signature: adebayo_signature,
  },
  {
    start: "2025-04-08",
    end: "2026-04-07",
    name: "CSP Olufunke Okerinde",
    rank: "O/C Central Motor Registry",
    signature: olufunke_signature,
  },
  {
    start: "2026-04-08",
    end: null,
    name: "ACP Uduak Edet",
    rank: "Asst. Commissioner of Police (CMR)",
    signature: edet_signature,
  },
];

// Core resolver (single engine for all 3 functions)
const resolveIssuer = (issue_date) => {
  const date = toDate(issue_date);
  if (!date) return null;

  return (
    TIMELINE.find((i) => {
      const start = new Date(i.start);
      const end = i.end ? new Date(i.end) : null;

      return date >= start && (!end || date <= end);
    }) || null
  );
};

// -----------------------------
// Public APIs (unchanged usage)
// -----------------------------

export const issuer_name = (issue_date) => {
  return resolveIssuer(issue_date)?.name || null;
};

export const issuer_signature = (issue_date) => {
  return resolveIssuer(issue_date)?.signature || null;
};

export const issuer_rank = (issue_date) => {
  return resolveIssuer(issue_date)?.rank || null;
};